import { useEffect, useState } from "react";
import { Radio, Wallet, ListChecks, Clock } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { Dispatch } from "@/components/driver/Dispatch";
import { Earnings } from "@/components/driver/Earnings";
import { TripsTable } from "@/components/fleet/BookingsPanel";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const ITEMS = [
  { key: "dispatch", label: "Dispatch", icon: Radio },
  { key: "earnings", label: "Earnings", icon: Wallet },
  { key: "trips", label: "My trips", icon: ListChecks },
];

const Waiting = ({ user }) => (
  <div data-testid="driver-pending-panel" className="max-w-xl rounded-2xl border border-amber-200 bg-amber-50 p-8">
    <Clock className="h-8 w-8 text-amber-600" />
    <h2 className="mt-4 text-xl font-semibold text-slate-900">
      {user.driver_status === "approved" ? "Waiting for a vehicle assignment" : user.driver_status === "pending" ? "Your registration is under review" : `Account ${user.driver_status}`}
    </h2>
    <p className="mt-2 text-sm text-slate-600">
      {user.driver_status === "approved"
        ? "You're approved! Comfort Taxi fleet staff will assign you a taxi shortly. You can go online once assigned."
        : user.driver_status === "pending"
        ? "The platform team will verify your licence and approve your account. Please check back soon."
        : "Please contact Comfort Taxi dispatch for assistance."}
    </p>
  </div>
);

const MyTrips = () => {
  const [trips, setTrips] = useState(null);
  useEffect(() => {
    api.get("/driver/trips").then((r) => setTrips(r.data)).catch(() => setTrips([]));
  }, []);
  return <TripsTable rows={trips} showCustomer />;
};

export default function DriverDashboard() {
  const { user, refresh } = useAuth();
  const [tab, setTab] = useState("dispatch");
  const ready = user.driver_status === "approved" && user.vehicle;
  return (
    <DashboardShell
      roleLabel="Driver"
      title={tab === "dispatch" ? "Dispatch" : tab === "earnings" ? "Earnings" : "My trips"}
      subtitle={user.vehicle ? `Taxi #${user.vehicle.taxi_no} · ${user.vehicle.plate} · ${user.vehicle.make} ${user.vehicle.model}` : "Comfort Taxi driver"}
      items={ITEMS}
      active={tab}
      onChange={(k) => { setTab(k); refresh(); }}
    >
      {!ready ? <Waiting user={user} /> : tab === "dispatch" ? <Dispatch /> : tab === "earnings" ? <Earnings /> : <MyTrips />}
    </DashboardShell>
  );
}
